<template>
    <div class="w-100">
        <!-- Header Section -->
        <div class="filter-header">
            <div class="fs-14 font-weight-bold ml-4">Filters <span style="color:#ffba00 !important;">({{totalFilters}})</span></div>
            <div class="pointer">
                <el-tooltip class="item" effect="dark" content="Close" placement="top">
                    <span @click="closeFilters()">
                        <img class="filter-Images" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/CloseBgBlue.svg" alt="close">
                    </span>
                </el-tooltip>
            </div>
        </div>
        <!-- Filter body Section -->
        <div class="row w-100 m-0">
            <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="mt-4">
                    <span class="fs-14 text-secondary font-weight-bold">
                        Auction Name
                    </span>
                    <multiselect :loading="auction_loading"
                        @search-change="searchAuction"
                        :limit="1"
                        :limit-text="limitAuctionTo"
                        placeholder="Select Auction Name"
                        class="digi-multiselect approval-manager filter-multiple mt-2"
                        :options="auction_name_options"
                        v-model="auction_name"
                        :multiple="true"
                        :searchable="true"
                        :internal-search="true"
                        :clear-on-select="false"
                        :close-on-select="true"
                        :options-limit="3000"
                        :max-height="200"
                        :show-no-results="true"
                        :hide-selected="false">
                        <template slot="tag" slot-scope="{ option }">
                            <span class="custom__tag">
                            <span class="filterSelectedName">{{ option }}</span>
                                <span class="custom__remove pointer" @click="removeAuctuionTo(option)">
                                <i class="icon icon-close fs-16 text-white"></i>
                                </span>
                            </span>
                        </template>
                        <template slot="afterList">
                            <div v-observe-visibility="reachedEndOfEmployees" />
                        </template>
                        <template slot="noResult">
                            <div class="text-secondary text-center fw-600">No Results Found</div>
                        </template>
                    </multiselect>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
                <div class=" mt-4">
                    <span class="fs-14 text-secondary font-weight-bold">
                        Auction Opening Date
                    </span>
                    <div class="mt-2 d-flex align-items-center">
                        <div v-if="auction_opening_date.length" style="border-bottom: 1px solid #a9aaad;width: 100%;">
                            <div class="d-flex justify-content-between align-items-center"
                                style="background: #00448b; border-radius: 20px; padding-left: 10px;padding-top: 4px;padding-bottom: 4px; padding-right: 10px; margin-top: 0px; margin-bottom: 8px; width: 120px;">
                                <input type="text"
                                    :value="auction_opening_date"
                                    style="color: #fff; background: #00448b;font-weight: 500;width: 8rem;" disabled />
                                <span
                                    @click="openingDateClose()"
                                    style="color: #fff; cursor: pointer;font-weight: 600;">&#10005;</span>
                            </div>
                        </div>
                        <date-picker v-else
                            v-model="auction_opening_date"
                            placeholder="Select Opening Date"
                            name="auction_opening_date"
                            class="meetinfdatetimes mx-left calendar-edit-per mr-1"
                            format="YYYY/MM/DD"
                            value-type="format"
                            type="date"
                            lang="en"
                            :not-after="auction_closing_date"
                            :clearable="false"
                            :editable="false"
                            confirm
                            confirm-text="APPLY"
                            @change="changeCount('start_date')"
                        ></date-picker>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="mt-4">
                    <span class="fs-14 text-secondary font-weight-bold">
                        Auction Closing Date
                    </span>
                    <!-- class="filterdate custom-popup filter-disable filter-date-underline policy-date-popup mr-1 w-100" -->
                    <div class="mt-2 d-flex align-items-center">
                        <div v-if="auction_closing_date.length" style="border-bottom: 1px solid #a9aaad;width: 100%;">
                            <div class="d-flex justify-content-between align-items-center"
                                style="background: #00448b; border-radius: 20px; padding-left: 10px;padding-top: 4px;padding-bottom: 4px; padding-right: 10px; margin-top: 0px; margin-bottom: 8px; width: 120px;">
                                <input type="text"
                                    :value="auction_closing_date"
                                    style="color: #fff; background: #00448b;font-weight: 500;width: 8rem;" disabled />
                                <span
                                    @click="closingDateClose()"
                                    style="color: #fff; cursor: pointer;font-weight: 600;">&#10005;</span>
                            </div>
                        </div>
                        <date-picker v-else
                            v-model="auction_closing_date"
                            placeholder="Select Closing Date"
                            name="auction_closing_date"
                            class="meetinfdatetimes mx-left calendar-edit-per mr-1"
                            format="YYYY/MM/DD"
                            value-type="format"
                            type="date"
                            lang="en" 
                            :not-before="auction_opening_date"
                            :clearable="false"
                            :editable="false"
                            confirm
                            confirm-text="APPLY"
                            @change="changeCount('end_date')"
                        ></date-picker>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex flex-wrap mb-2 mt-2 mr-3" style="float: right !important;">
            <button class="btn mt-2 ml-6 new-reset-button" @click="clearAllSelected()">Reset</button>
            <button class="btn mt-2 ml-6 new-apply-button" @click="applyFilter">Apply</button>
        </div>
    </div>
</template>
<script>
import { EventBus } from '../eventBus/nav-bar-event';
import { debounce } from 'lodash'
import Auction from "../mixins/auction.js"
export default {
    mixins: [Auction],
    props: ["showfilterData"],
    data(){
        return{
            auction_name: [],
            auction_name_options: [],
            auction_opening_date: "",
            auction_closing_date:"",
            auction_loading: false,
            template: [],
            date_count: 0,
            start_date_reached: false,
            end_date_reached: false,
            auction_count: 0,
            auction_scrollable: false,
            auction_visible: false,
            auction_loading: false,
            selected_field: '',
            value_targeted: 0
        }
    },
    methods:{
        openingDateClose(){
            this.auction_opening_date = ""
        },
        closingDateClose(){
            this.auction_closing_date = ""
        },
        //To search auction
        async searchAuctionDebouncer(search_key) {
            this.search_key = search_key
            this.auction_loading = true
            try {
                let params = {
                    search_key: search,
                    "limit": 10,
                    "search_key": this.search_key,
                    "skip": 0,
                    "sort_key": "auction_name",
                    "sort_value": -1,
                };
                let response = await this.getAuctionsList(params)
                this.auction_name_options = response.data.auction_data;
                this.auction_count = response.data.auction_data.length;
                this.auction_loading = false
            }
            catch(error) {
            }
        },
        //Lazy loading for auction names field
        async reachedEndOfEmployees(reached) {
            this.auction_visible = reached
            if (reached) {
                if (this.auction_scrollable == false) {
                    this.auction_loading = true
                    let response = await this.getAuctionsList({
                        "filter_json": {},
                        "limit": 10,
                        "search_key": this.search_key,
                        "skip": this.auction_count,
                        "sort_key": "auction_name",
                        "sort_value": -1,
                    })
                    this.temp_products = response.data.auction_data.length;
                    if (response.data.skip == this.auction_count) {
                        if (this.temp_products > 0) {
                            let tempFiles = response.data.auction_data;
                            tempFiles.forEach(el => {
                                this.auction_name_options.push(el.auction_name);
                            });
                            // this.auction_name_options = this.auction_name_options.filter((thing, index) => {
                            //     const payload = JSON.stringify(thing);
                            //     return index === this.auction_name_options.findIndex(obj => {
                            //         return JSON.stringify(obj) === payload;
                            //     });
                            // });
                            this.auction_count += response.data.auction_data.length;
                            this.auction_loading = false
                        } else {
                            this.auction_scrollable = true
                            this.auction_loading = false
                        }
                    }
                    this.auction_loading = false
                }
            }
        },
        //To reset all selected data
        resetData(type){
            this.selected_field = type
            this.auction_name_options = [];
            this.auction_count = 0;
        },
        changeCount(obj){
            if(obj == 'start_date'){
                if(!this.start_date_reached){
                    this.date_count += 1;
                }
                this.start_date_reached = true
            } else if(obj == 'end_date'){
                if(!this.end_date_reached){
                    this.date_count += 1;
                }
                this.end_date_reached = true
            }
        },
        //Removes selected auction
        removeAuctuionTo(option){
            this.auction_name.forEach((el,index)=>{
                if(el._id == option._id){
                    this.auction_name.splice(index,1)
                }
            })
        },
        limitAuctionTo(count){
            return `+ ${count} more`
        },
        closeFilters(){
            this.hide_filters = false
            this.$emit('hideFilters')
        },
        //To clear all selected data
        clearAllSelected(){
            this.auction_name = [],
            this.auction_opening_date = ""
            this.auction_closing_date = ""
            this.date_count = 0
            let newData = {
                filterData: {
                    auction_name: [],
                    auction_opening_date: "",
                    auction_closing_date: ""

                },
                showfilterData: {
                    auction_name: [],
                    auction_opening_date: "",
                    auction_closing_date: ""
                }
            }
            this.date_count = 0
            this.start_date_reached = false
            this.end_date_reached = false
        },
         convertFilter(str) {
            var date = new Date(str),
                mnth = ("0" + (date.getMonth() + 1)).slice(-2),
                day = ("0" + date.getDate()).slice(-2);
            return [day, mnth, date.getFullYear()].join("-");
        },
        applyFilter(){
            let params = {
                auction_name:this.auction_name,
                // created_industry_type:[...new Set(this.industry_type.map(x =>x.industry_type))],
                // created_template:[...new Set(this.template.map(x =>x.template_type))],
                // created_status:[...new Set(this.status.map(x =>x.status))],
                auction_opening_date: this.auction_opening_date,
                auction_closing_date: this.auction_closing_date,
            }
            let params1 = {
                auction_name:this.auction_name,
                auction_opening_date: this.auction_opening_date,
                auction_closing_date: this.auction_closing_date,
            }
            let newData = {
                value: params,
                value1: params1
            }
            this.$emit('UpdateByFilter', newData)
            this.closeFilters();
        },
        
    },
    async mounted(){
        this.auction_name= this.showfilterData.auction_name
        this.auction_opening_date = this.showfilterData.auction_opening_date
        this.auction_closing_date = this.showfilterData.auction_closing_date
    },
    created(){
        this.searchAuction = debounce(this.searchAuctionDebouncer, 500)
    },
    computed: {
        totalFilters(){
            return this.date_count + this.auction_name.length;
        }
    },
}
</script>
<style scoped>
    .place-holder{
        margin-left: 10px;
    }
    .pl-ho input.mx-input::-webkit-input-placeholder {
        color: #7b7f83 !important;
        line-height: 1.42857143 !important;
        font-size: 13px !important;
        font-weight: normal !important;
        padding-left: 10px !important
    }
    .pl-ho input.mx-input::placeholder {
        color: #7b7f83 !important;
        line-height: 1.42857143 !important;
        font-size: 13px !important;
        font-weight: normal !important;
        padding-left: 10px !important
    }
    .pl-ho input.mx-input::-moz-placeholder {
        color: #7b7f83 !important;
        line-height: 1.42857143 !important;
        font-size: 13px !important;
        font-weight: normal !important;
        padding-left: 10px !important
    }
    .pl-ho input.mx-input:-moz-placeholder {
        color: #7b7f83 !important;
        line-height: 1.42857143 !important;
        font-size: 13px !important;
        font-weight: normal !important;
        padding-left: 10px !important
    }
    .pl-ho input.mx-input:-ms-input-placeholder {
        color: #7b7f83 !important;
        line-height: 1.42857143 !important;
        font-size: 13px !important;
        font-weight: normal !important;
        padding-left: 10px !important
    }
    .multiselect__select:before{
        border-color: #303031 transparent transparent !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/Auction/auctionFilterData.vue